import { Image } from '@model/common/image';
import { breakpoints } from '@styles/breakpoints';
import { getImageUrl } from './images';

export const getCrossfadeImages: (hero: Image, gallery: Array<Image>) => Array<Image> = (
  hero: Image,
  gallery: Array<Image>
) => {
  const resizedHeroImage = hero && {
    ...hero,
    url: `${getImageUrl(hero.url, breakpoints.small)}`
  };
  const resizedGalleryImages = gallery
    ? gallery.map((image: Image) => ({
        ...image,
        url: `${getImageUrl(image.url, breakpoints.small)}`
      }))
    : [];

  return [resizedHeroImage, ...resizedGalleryImages].filter((image: Image) => image);
};
